import { useQuery } from '@tanstack/react-query';
import { appelApi } from './api';
import { Pastille } from '../components/ui/Primitives';

export interface DashboardCommercialData {
  compteurs: {
    entretiensCetteSemaine: number;
    detailEntretiens: string;
    postesOuverts: number;
    candidatsAPositionner: number;
    detailCandidats: string;
    tauxPlacement: string | null;
  };
  pipeline: {
    id: string;
    titre: string;
    sousTitre: string;
    statut: string;
    ton: Parameters<typeof Pastille>[0]['ton'];
    page: string;
    site?: string;
  }[];
  accesRapides: {
    id: string;
    titre: string;
    sousTitre: string;
    page: string;
  }[];
  alertes: {
    id: string;
    titre: string;
    sousTitre: string;
    ton: 'warning' | 'danger' | 'info';
  }[];
}

export function useDashboardCommercial(site: string) {
  const parametres = new URLSearchParams({ site });
  return useQuery({
    queryKey: ['dashboard', 'commercial', site],
    queryFn: () =>
      appelApi<DashboardCommercialData>(`/dashboard/commercial?${parametres.toString()}`),
  });
}
